import React, { useState, useEffect } from "react";
import { ReactComponent as StarFilled } from "../assets/svg/star-filled.svg";
import { ReactComponent as StarEmpty } from "../assets/svg/star-empty.svg";

const RatingStars = ({ maxStars = 5, onSubmit, initialRating = 0, disabled = false }) => {
    const [rating, setRating] = useState(initialRating);
    const [hover, setHover] = useState(0);

    // ✅ Sync with DB (when user reloads and we fetch initial rating)
    useEffect(() => {
        setRating(initialRating);
    }, [initialRating]);

    return (
        <div className="flex items-center gap-2 flex-wrap">
            <span className="font-medium text-sm md:text-base">Rating:</span>

            <div className="flex items-center gap-1 md:gap-2 bg-[#3d6b7c] rounded-2xl px-3 py-2">
                {[...Array(maxStars)].map((_, index) => {
                    const starValue = index + 1;
                    const isActive = starValue <= (hover || rating);

                    return (
                        <div
                            key={starValue}
                            className={`w-5 h-5 md:w-6 md:h-6 transition-transform flex items-center justify-center 
                    ${!disabled ? "cursor-pointer hover:scale-110" : "opacity-70 cursor-not-allowed"}`}
                            onClick={() => !disabled && setRating(starValue)}
                            onMouseEnter={() => !disabled && setHover(starValue)}
                            onMouseLeave={() => !disabled && setHover(0)}
                        >
                            {isActive ? <StarFilled /> : <StarEmpty />}
                        </div>
                    );
                })}
            </div>

            {disabled ? (
                <span className="px-3 py-2 rounded-xl bg-gray-500 text-white font-semibold text-xs md:text-sm">
                    Rated ✓
                </span>
            ) : (
                <button
                    className="px-3 py-2 rounded-xl bg-[#3d6b7c] text-white font-semibold hover:opacity-90 transition text-xs md:text-sm"
                    onClick={() => rating !== 0 && onSubmit(rating)}
                >
                    Submit ✓
                </button>
            )}
        </div>
    );
};

export default RatingStars;
